import "./assets/scss/themes.scss";
import Route from "./Routes/index";
import trTR from "antd/locale/tr_TR";
import { ConfigProvider } from "antd";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const App = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.ym) {
      window.ym("98428588", "hit", location.pathname);
    }
  }, [location]);

  return (
    <>
      <ConfigProvider locale={trTR}>
        <Route />
      </ConfigProvider>
    </>
  );
};

export default App;
